import {lazy} from 'react';
import GenericFallbackSuspense from '../../../../../v2/components/ui/GenericFallback/GenericFallbackSuspense';

const SezzleOverlayBody = lazy(() => import('./SezzleOverlayBody'/* webpackChunkName: 'SezzleOverlayBody' */));

export default function SezzleOverlayLazyLoader() {
  return (
    <GenericFallbackSuspense>
      <SezzleOverlayBody />
    </GenericFallbackSuspense>
  );
}
